import WatchComponent from "components/Watch";

export default function Watch() {
  return <WatchComponent />;
}
